import DBLNegocios from './DBL Negocios';
import GrupoMMNegocios from './Grupo MM Negocios';
import GrupoMMParticular from './Grupo MM Particular';
import PepephoneParticular from './Pepephone Particular';
import YoigoNegocios from './Yoigo Negocios';
import YoigoParticular from './Yoigo Particular';
import VirginParticular from './Virgin Particular';
import AvatelParticular from './Avatel Particular';

export default {
    DBLNegocios,
    GrupoMMNegocios,
    GrupoMMParticular,
    PepephoneParticular,
    YoigoNegocios,
    YoigoParticular,
    VirginParticular,
    AvatelParticular,
};